<template>
    <div >
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <NavBar :key="StudentUserId"></NavBar>
        <div class="container-fluid p-2">
            <div class="d-flex justify-content-between">
                <h4>{{ $t('calendar.bookedList') }}</h4>
                <!--<button class="ShareBTN"><router-link :to="`/BookingLesson`">訂課</router-link></button>-->
                <button class="ShareBTN" data-toggle="modal" data-target="#ChooseGroupModal" @click="ShowChooseGroupModal()" v-if="loginInputData.CustomerCode!=1099 && loginInputData.CustomerCode!=1258">
                    {{ $t('calendar.book') }}
                </button>
            </div>
                <div class=" HomeBookingList p-1">
                    <!--行事曆-->
                    <div class="FullCalendarDiv m-2">
                        <FullCalendar ref="fullCalendar" :options="calendarOptions" 
                            data-toggle="modal" data-target="#LessonDetailModal" />
                    </div>
                </div>
            </div>

            <!-- LessonDetailModal -->        
            <div class="modal fade" id="LessonDetailModal" tabindex="-1" aria-labelledby="LessonDetailModalLabel" data-backdrop="static" aria-hidden="true" v-if="showLessonDetailModal">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h6 class="modal-title" id="LessonDetailModalLabel">{{DateCode}}({{ $t('classInfo.classroomId') }}：{{SelectedLessonObject.ClassroomId}})</h6>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showLessonDetailModal = false">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body p-2">
                            <div class="d-flex py-2">
                                <div class="DetailTitle">
                                    <span>{{ $t('classInfo.lessonName') }}：</span>
                                </div>
                                <div>{{SelectedLessonObject.LessonName}}
                                </div>
                            </div>
                            <div class="d-flex py-2">
                                <div class="DetailTitle">
                                    <span>{{ $t('classInfo.lessonTime') }}：</span>
                                </div>
                                <div>
                                    {{dateFormat(SelectedLessonObject.StartTimeStamp)}}-{{dateFormat(SelectedLessonObject.EndTimeStamp)}}
                                </div>
                                <div class="ml-auto">
                                    <button class="ShareBTN" @click="PreviewMaterial()">{{ $t('classInfo.materail') }}</button>
                                </div>
                            </div>
                            <div class="d-flex py-2">
                                <div class="DetailTitle">
                                    <span>{{ $t('classInfo.teacher') }}：</span>
                                </div>
                                <div>
                                    {{SelectedLessonObject.TeacherName}}({{SelectedLessonObject.TeacherId}})
                                </div>
                            </div>
                            <div class="d-flex py-2">
                                <div class="DetailTitle">
                                    <span>{{ $t('classInfo.record') }}：</span>
                                </div>
                                <div>
                                    <button class="ShareBTN" @click="LessonRecord()">{{ $t('classInfo.lessonRecord') }}</button>
                                </div>
                            </div>
                            <div class="d-flex py-2">
                                <div class="DetailTitle">
                                    <span>{{ $t('classInfo.lessonStatus') }}：</span>
                                </div>
                                <div>
                                    {{SelectedLessonObject.State}}
                                </div>
                                <div class="ml-auto">
                                    <button class="ShareBTN" @click="StudentCancelBooking()" v-if="SelectedLessonObject.CanCancel && loginInputData.CustomerCode!=1099" data-dismiss="modal">
                                        {{ $t('classInfo.cancelClass') }}
                                    </button>
                                </div>
                            </div>
                            <div class="d-flex py-2">
                                <div class="DetailTitle">
                                    <span>{{ $t('classInfo.classUrl') }}：</span>
                                </div>
                                <div>
                                    <button class="ShareBTN" @click="EnterClassroom(SelectedLessonObject)" v-if="SelectedLessonObject.EnterClassroomTag">{{ $t('classInfo.enterClass') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- ChooseGroupModal -->
            <div class="modal fade" id="ChooseGroupModal" tabindex="-1" aria-labelledby="ChooseGroupModalLabel" aria-hidden="true" v-if="CashType == 0">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body ">
                            <div class="">
                                <span>{{ $t('classInfo.chooseGroupClassType') }}</span>
                                <div class="p-2">
                                    <button class="ShareBTN ChooseGroupButton" data-dismiss="modal" @click="GoIsGroupOrNot(true)">{{ $t('classInfo.groupClass') }}</button>
                                </div>
                                <div class="p-2">
                                    <button class="ShareBTN ChooseGroupButton" data-dismiss="modal" @click="GoIsGroupOrNot(false)">{{ $t('classInfo.specialClass') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
</template>


<script>
import NavBar from '@/components/NavBar'
import HomeForm from '@/components/HomeForm'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import md5 from 'js-md5'
import $ from 'jquery'
/*calendar*/
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'

export default {
    name: 'Home',
    components:{
        NavBar,HomeForm,FullCalendar
    },
    data () {
        return {
            DateCode:moment(new Date()).format('yyyy-MM-DD'),
            ClassroomObject:[],
            SelectedLessonObject:[],
            studentId:"",
            StudentUserId:"",
            StudentName:"",
            EnglishName:"",
            NoticeMail:"",
            Token:"",
            CustomerCode:'',
            loginInputData:{
                Token :'',
                CustomerCode:'',
                StudentId:''
            },
            NoLessonNote:'',
            showLoading:false,
            showLessonDetailModal:false,
            CashType:this.GLOBAL.CashType,
            IsSpeedTest:false,
            todat:this.today,
            calendarOptions: {
                plugins: [ dayGridPlugin, interactionPlugin ,listPlugin  ],
                initialView : window.innerWidth < 720 ? 'listWeek':'dayGridMonth',
                headerToolbar: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'today'
                },
                events:[],
                locale: 'en-GB',
                eventClick:this.selectedLesson,
                height: 800,
                eventDisplay: 'auto',
                eventTimeFormat: { 
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                },
                customButtons: {
                    prev: {
                        text: this.$t('calendar.prevMonth'),
                        click: () => {           
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.prev();
                            this.SetCalendarDate();
                        }
                    },
                    next: { 
                        text: this.$t('calendar.nextMonth'),
                        click: () => {      
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.next();
                            this.SetCalendarDate();
                        }
                    },
                    today: {
                        text:this.$t('calendar.today'),
                        click: () => {           
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.today();
                            this.SetCalendarDate();
                        }
                    },
                },
            }
        }
    },
    methods:{
        SetCalendarDate(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            this.DateCode = moment(calendarApi.getDate()).format('yyyy-MM-DD');
            this.GetCalendarByDate();
        },
        selectedLesson(info){
            // console.log(info.event._def.extendedProps);
            this.showLessonDetailModal = true;
            this.SelectedLessonObject = JSON.parse(JSON.stringify(info.event._def.extendedProps));
            this.DateCode = moment.unix(this.SelectedLessonObject.StartTimeStamp).format('yyyy-MM-DD');
            //在課前4小時取消
            if(moment(new Date()).add(4, 'hours').format('yyyy-MM-DD HH')
                <= moment.unix(this.SelectedLessonObject.StartTimeStamp).format('yyyy-MM-DD HH')){
                this.SelectedLessonObject.CanCancel =  true;
            }else{
                this.SelectedLessonObject.CanCancel =  false;
            }
        },

        //教材預覽
        PreviewMaterial(){
            window.open(this.SelectedLessonObject.PreviewOrReviewUrl, '_blank');
        },

        //上課紀錄
        LessonRecord(){
            window.open(this.SelectedLessonObject.LessonRecordUrl, '_blank');
        },

        //進入教室
        EnterClassroom(Classroom){
            //如果如果IsSpeedTest=TRUE，新增一顆【跳過檢測】按鈕，點選後直接進入教室連結ClassroomUrl
            //(如果IsSpeedTest=FALSE或者前端抓不到IsSpeedTest這個參數跟內容，就不需要顯示這顆按紐)

            if(this.loginInputData.CustomerCode == 1099){                
                sessionStorage.setItem('ClassroomId',Classroom.ClassroomId);
                //sessionStorage.setItem('ClassroomUrl',Classroom.ClassroomUrl);
                $('.modal-backdrop').remove();
                this.$router.push({
                    name: 'CheckDeviceTest',
                    params: {
                        IsSpeedTest:this.IsSpeedTest,
                        ClassroomUrl:Classroom.ClassroomUrl,
                        ClassroomId:Classroom.ClassroomId,
                        CustomerCode:this.loginInputData.CustomerCode,
                    }
                });
            }else{
                window.open(Classroom.ClassroomUrl, '_blank');
            }
        },
        ShowChooseGroupModal(){
            if(this.GLOBAL.CashType == 1){
                this.GoIsGroupOrNot(true)
            }else if(this.GLOBAL.CashType == 2){
                this.GoIsGroupOrNot(false)
            }
        },
        GoIsGroupOrNot(IsGroupOrNot){
            if(IsGroupOrNot){
                // 團課
                this.$router.push({
                    name: 'BookingLessonGroup',
                    params: {}
                });
            }else{
                // 專班
                this.$router.push({
                    name: 'BookingLesson',
                    params: {}
                });
            }
        },

        /*API*/
        //取得已訂課清單
        GetCalendarByDate(){
            this.calendarOptions.events = [];
            this.showLoading = true;
            this.NoLessonNote ='';
            this.ClassroomObject = [];
            const api =`${process.env.APIPATH}/api/Student/GetCalendarByDate`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const input =
            {
                "StartTimeStamp": moment(this.DateCode).startOf("month").format("X"),
                "EndTimeStamp": moment(this.DateCode).endOf("month").format("X")
            }
            axios.post(api, input, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        this.IsSpeedTest = response.data.IsSpeedTest;
                        if(response.data.ClassroomObjects.length > 0){    
                            this.ClassroomObject = response.data.ClassroomObjects;
                            response.data.ClassroomObjects.forEach(Item => {
                                    this.calendarOptions.events.push({
                                        title:Item.LessonName + ' ' + Item.TeacherName ,
                                        start:moment.unix(Item.StartTimeStamp).format("yyyy-MM-DDTHH:mm"),
                                        end:moment.unix(Item.EndTimeStamp).format("yyyy-MM-DDTHH:mm"),
                                        StartTimeStamp: Item.StartTimeStamp,
                                        EndTimeStamp: Item.EndTimeStamp,
                                        BookingStudentId: Item.BookingStudentId,
                                        ClassroomId: Item.ClassroomId,
                                        ClassroomUrl: Item.ClassroomUrl,
                                        Gender: Item.Gender,
                                        IsSubstitute: Item.IsSubstitute,
                                        IsTrial: Item.IsTrial,
                                        LessonId: Item.LessonId,
                                        LessonName: Item.LessonName,
                                        LessonNameEnglish: Item.LessonNameEnglish,
                                        LessonRecordUrl: Item.LessonRecordUrl,
                                        LessonTime: Item.LessonTime,
                                        PreviewOrReviewUrl: Item.PreviewOrReviewUrl,
                                        State: Item.State,
                                        SubstituteFrom: Item.SubstituteFrom,
                                        TeacherId: Item.TeacherId,
                                        TeacherName: Item.TeacherName,
                                        TeacherPhotoUrl: Item.TeacherPhotoUrl,
                                        languageType: Item.languageType,
                                        nationalGroup: Item.nationalGroup,
                                        CanCancel:true,
                                        EnterClassroomTag:Item.EnterClassroomTag
                                    });
                                });
                        }else{
                            this.NoLessonNote = this.$t('classInfo.noLessonNote');
                            this.ClassroomObject = [];
                        }
                    }else{
                        if(response.data.errorCode == 20002){
                            alert(this.$t('classInfo.timeout'));
                        }
                        this.NoLessonNote = this.$t('classInfo.noLessonNote');
                        this.ClassroomObject = [];
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert(this.$t('classInfo.getClassedListError')+ error.message);
                });
        },
        //取消訂課
        StudentCancelBooking(){
            var confirmCancel = confirm(this.$t('classInfo.checkCancel'))
            if(confirmCancel){
                this.showLoading = true;
                $('.modal-backdrop').remove();
                this.showLessonDetailModal = false
                const api =`${process.env.APIPATH}/api/Student/StudentCancelBooking`;
                const headers = {"Authorization": 'Bearer '+this.Token};
                const input = {
                    "ClassroomId":this.SelectedLessonObject.ClassroomId
                }
                    
                axios.post(api, input, { headers })
                    .then((response) => {
                        this.showLoading = false;
                        if(response.data.Result){
                            alert("課程取消成功！");
                            this.GetCalendarByDate();
                        }else{
                            if(response.data.errorCode == 20002){
                                alert("閒置時間過長，請重新進入。");
                            }else{
                                alert("課程取消失敗：" + response.data.Message);
                            }
                        }
                    })
                    .catch(error => {
                        this.showLoading = false;
                        this.errorMessage = error.message;
                        console.error("There was an error!", error);
                        alert("取消訂課失敗："+ error.message);
                    });
            }
                
        },
        
        dateFormat(timestamp,type){
            if(timestamp && timestamp != "")
            {
                if(type == 0){
                    return moment.unix(timestamp).format("yyyy-MM-DD HH:mm:ss");
                }else{
                    return moment.unix(timestamp).format("HH:mm");
                }
            }
            return "";
        },        
        changeLang(lang){
            app.$i18n.locale=lang;
        },
        updateTranslatedMessages() {
            console.log("test".this.$t('calendar.prevMonth'));
            this.calendarOptions.customButtons.prev.text = this.$t('calendar.prevMonth');
            this.calendarOptions.customButtons.next.text = this.$t('calendar.nextMonth');
            this.calendarOptions.customButtons.today.text = this.$t('calendar.today');
        }
    },
    created(){
        if(this.$route.query.UserKey != undefined){
            this.loginInputData = JSON.parse(window.atob(this.$route.query.UserKey.toString()));
            this.Token = this.loginInputData.Token;
            sessionStorage.setItem('CustomerCode',this.loginInputData.CustomerCode);
            sessionStorage.setItem('StudentId',this.loginInputData.StudentId);
            var data={}

            //Axios
            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/Student/LoginStudentCenter`;
            axios.post(api, data, { headers })
                .then((response) => {
                    this.studentId=response.data.StudentId;
                    this.StudentName=response.data.StudentName;
                    this.NoticeMail=response.data.NoticeMail;
                    sessionStorage.setItem('Token',this.Token);
                    sessionStorage.setItem('StudentUserId',response.data.StudentUserId);
                    sessionStorage.setItem('EnglishName',response.data.EnglishName);
                    this.GLOBAL.StudentUserId = response.data.StudentUserId;
                    this.GLOBAL.EnglishName = response.data.EnglishName;
                    this.EnglishName = this.GLOBAL.EnglishName;
                    this.StudentUserId = this.GLOBAL.StudentUserId;
                    this.CashType = this.GLOBAL.CashType = response.data.CashType;
                    // this.CashType = this.GLOBAL.CashType;
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        }
        else{
            this.Token = sessionStorage.getItem('Token');
            this.loginInputData.CustomerCode = sessionStorage.getItem('CustomerCode');
        }
        this.GetCalendarByDate();
    },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue